import React, {useEffect} from "react";
import {Link} from "react-router-dom";
import SimpleBar from "simplebar-react";
//Import Components
import VerticalLayout from "./VerticalLayouts/index";
import TwoColumnLayout from "./TwoColumnLayout";
import {Container} from "reactstrap";
import HorizontalLayout from "./HorizontalLayout";
import salescrm from "../assets/images/sales-crm.png";
import salesNinja from "../../src/assets/images/sales-ninja.png";
import salesFevicon from "../../src/assets/images/salesNinja-fevicon.png";
import darkthemelogo from "../assets/images/logo-main-white.png";
const Sidebar = ({layoutType}) => {
    const loginType = JSON.parse(localStorage.getItem("logintype"));
    const SuperAdminlogintype = JSON.parse(localStorage.getItem("SuperAdminlogintype"));
    useEffect(() => {
        var verticalOverlay = document.getElementsByClassName("vertical-overlay");
        if (verticalOverlay) {
            verticalOverlay[0].addEventListener("click", function () {
                document.body.classList.remove("vertical-sidebar-enable");
            });
        }
    });

    const addEventListenerOnSmHoverMenu = () => {
        // add listener Sidebar Hover icon on change layout from setting
        if (document.documentElement.getAttribute("data-sidebar-size") === "sm-hover") {
            document.documentElement.setAttribute("data-sidebar-size", "sm-hover-active");
        } else if (document.documentElement.getAttribute("data-sidebar-size") === "sm-hover-active") {
            document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
        } else {
            document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
        }
    };

    // ✅ ADDED: Mobile sidebar close on menu click
const closeSidebarOnMobile = (e) => {
  if (window.innerWidth > 768) return;

  const link = e.target.closest("a");
  if (!link) return;

  /**
   * Dropdown parent tabhi maana jayega jab:
   * 1. data-bs-toggle="collapse" ho
   * 2. uske baad actual submenu (.menu-dropdown) exist kare
   */

  const hasSubMenu =
    link.getAttribute("data-bs-toggle") === "collapse" &&
    link.nextElementSibling &&
    link.nextElementSibling.classList.contains("menu-dropdown");

  // ❌ Parent dropdown → sidebar open rahe
  if (hasSubMenu) return;

  // ✅ Leaf node (Dashboard / submenu item)
  document.body.classList.remove("vertical-sidebar-enable");
};
    return (
        <React.Fragment>
            <div className="app-menu navbar-menu sn-sideBar-navbar-main sn-left-side-menu-bar-main-page">
                <div className="navbar-brand-box">
                    <Link className="logo logo-dark">
                        <span className="logo-sm">
                            <img src={salesFevicon} alt="" height="28" />
                            {/* <img src={salescrm} alt="" height="22" /> */}
                        </span>

                        <span className="logo-lg header-logo-side-bar">
                            <Link to={SuperAdminlogintype === "SuperAdmin" ? "/admin-dashboard" : "/dashboard"}>
                                <img src={salesNinja} className="lightthemelogo" alt="" height="35" />
                                <img src={darkthemelogo} className="darkthemelogo" alt="" height="35" />
                            </Link>

                            {/* <img src='https://salesninja.asia/wp-content/uploads/2020/12/sales-ninja-logo.png' alt="" height="25" /> */}
                        </span>
                    </Link>
                    <button
                        onClick={addEventListenerOnSmHoverMenu}
                        type="button"
                        className="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover"
                        id="vertical-hover"
                    >
                        <i className="ri-record-circle-line"></i>
                    </button>
                </div>
                {layoutType === "horizontal" ? (
                    <div id="scrollbar">
                        <Container fluid>
                            <div id="two-column-menu"></div>
                            <ul className="navbar-nav sdsdsdssd" id="navbar-nav" onClick={closeSidebarOnMobile}>
                                <HorizontalLayout />
                            </ul>
                        </Container>
                    </div>
                ) : layoutType === "twocolumn" ? (
                    <React.Fragment>
                        <TwoColumnLayout layoutType={layoutType} />
                        <div className="sidebar-background"></div>
                    </React.Fragment>
                ) : (
                    <React.Fragment>
                        <SimpleBar id="scrollbar" className="h-100">
                            <Container fluid>
                                <div id="two-column-menu"></div>
                                <ul
                                    className="navbar-nav sn-side-menu-barrr"
                                    id="navbar-nav"
                                    onClick={closeSidebarOnMobile}
                                >
                                    <VerticalLayout layoutType={layoutType} />
                                </ul>
                            </Container>
                        </SimpleBar>
                        <div className="sidebar-background"></div>
                    </React.Fragment>
                )}
            </div>
            <div className="vertical-overlay"></div>
        </React.Fragment>
    );
};

export default Sidebar;
